import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Tomo {
  emoji: string;
  title: string;
  items: string[];
  highlight?: string;
}
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const tomos: Tomo[] = [{
    emoji: '📘',
    title: 'TOMO 1 — PSICOLOGÍA DE LOS GRUPOS Y VÍNCULOS',
    items: ['Conceptos clave: grupos, roles, liderazgo, bullying', 'Autores fundamentales: Lewin, Pichon-Rivière, Bion', '5 clases listas para usar', 'Actividades prácticas + sociograma + evaluación', 'Protocolos para conflictos y bullying']
  }, {
    emoji: '📘',
    title: 'TOMO 2 — IDENTIDAD Y ADOLESCENCIA',
    items: ['Identidad, adolescencia y construcción personal', 'Redes sociales, FOMO, salud mental', 'Género y ESI', '5 clases completas listas', 'Actividades + casos reales + evaluación', 'Intervención en acoso digital y crisis']
  }, {
    emoji: '📘',
    title: 'TOMO 3 — PROCESOS COGNITIVOS Y APRENDIZAJE',
    items: ['Piaget, Vygotsky y teorías del aprendizaje', 'Memoria, atención, motivación y metacognición', '9 clases completas con evaluación', 'Actividades prácticas + proyectos', 'Inclusión (NEE) y gestión de aula', 'Evaluación con criterios claros']
  }, {
    emoji: '📘',
    title: 'TOMO 4 — PSICOANÁLISIS Y SUBJETIVIDAD',
    items: ['Freud, Winnicott y Lacan explicados fácil', 'Conceptos clave: inconsciente, identidad, subjetividad', 'Analogías modernas para facilitar la enseñanza', 'Guías de lectura + glosario'],
    highlight: 'Ideal para enseñar teoría compleja de forma clara'
  }, {
    emoji: '📘',
    title: 'TOMO 5 — DINÁMICAS Y ACTIVIDADES PARA EL AULA',
    items: ['Actividades listas para aplicar', 'Debates, análisis de casos y mapas conceptuales', 'Fichas imprimibles', 'Rúbricas profesionales + autoevaluación'],
    highlight: 'No preparás más actividades desde cero'
  }, {
    emoji: '📘',
    title: 'TOMO 6 — GESTIÓN ÁULICA Y CONTENCIÓN',
    items: ['Manejo de conflictos y situaciones difíciles', 'Protocolos de intervención', 'Inclusión y diversidad (NEE)', 'Estrategias reales para el aula'],
    highlight: 'Herramientas concretas para el día a día'
  }];
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-4 md:py-5 px-4" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-140">
          ¿QUÉ INCLUYE EL KIT COMPLETO PSICOLOGÍA LISTA?
        </h2>

        <div className="flex flex-col gap-2" data-id="element-141">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-gray-50" data-id="element-142">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between gap-3 p-3.5 md:p-4 text-left hover:bg-gray-100 transition-colors" data-id="element-143">
                  <span className="flex items-center gap-2.5" data-id="element-144">
                    <span className="text-2xl leading-none" data-id="element-145">{tomo.emoji}</span>
                    <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-146">
                      {tomo.title}
                    </span>
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="flex-shrink-0" data-id="element-147">
                    <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-148" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-149">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-150">
                      <div className="px-4 pb-4 pt-1 border-t border-gray-200" data-id="element-151">
                        <ul className="space-y-1.5" data-id="element-152">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm md:text-base" data-id="element-153">
                              <span className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-154">
                                ✔
                              </span>
                              <span data-id="element-155">{item}</span>
                            </li>)}
                        </ul>
                        {tomo.highlight && <p className="mt-2.5 text-sm font-semibold text-blue-700 flex items-center gap-1.5" data-id="element-156">
                            <span data-id="element-157">👉</span> {tomo.highlight}
                          </p>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}